module.exports = __webpack_public_path__ + "img/slider-4.1e62b1a7.jpg";